/* istanbul ignore file */

export const UKV_AND_VKB_INSURANCE_NUMBER_REGEX = /^KK-\d{4}-\d{4}$/;
